// STAFF-S1 — the one definition of "in staff" (в състав) on the frontend.
// Must match HRApp.Core.Enums.EmployeeStatusSets.InStaff on the server:
// working people, including probation, notice period, leave and suspension.
// Terminated, Inactive and Retired are former staff.
export const IN_STAFF_STATUSES = [
  'Active',
  'Probation',
  'NoticePeriod',
  'OnLeave',
  'OnMaternityLeave',
  'OnSickLeave',
  'Suspended',
];

// Order of HRApp.Core.Enums.EmployeeStatus, for payloads that carry the number.
const STATUS_BY_NUMBER = [
  'Active', 'Inactive', 'Terminated', 'OnLeave', 'OnMaternityLeave',
  'OnSickLeave', 'Probation', 'Suspended', 'NoticePeriod', 'Retired',
];

export function normalizeEmployeeStatus(status) {
  if (typeof status === 'number') return STATUS_BY_NUMBER[status] ?? null;
  if (typeof status === 'string' && status.trim() !== '') return status.trim();
  return null;
}

// A row without a status (e.g. the server already filtered it) counts as in staff.
export function isInStaff(status) {
  const s = normalizeEmployeeStatus(status);
  return s === null || IN_STAFF_STATUSES.includes(s);
}

// Employees in staff, plus the currently selected one so an existing value still shows.
export function inStaffOnly(employees, keepId = null) {
  const list = Array.isArray(employees) ? employees : [];
  const keep = keepId === null || keepId === undefined || keepId === '' ? null : keepId;
  return list.filter((e) => isInStaff(e?.status ?? e?.Status)
    || (keep !== null && (e?.id ?? e?.Id) === keep));
}
